export const milestoneFields = [
    "Log.MS.Date.Started",
    "Log.MS.Date.Registered",
    "Log.MS.Date.Setup",
    "Log.MS.Date.Loan Pkg Submitted",
    "Log.MS.Date.Submitted to UW",
    "Log.MS.Date.Cond. Approval",
    "Log.MS.Date.Final UW",
    "Log.MS.Date.CTC",
    //"Log.MS.Date.Ready for Docs",
    "Log.MS.Date.Funding",
    "Log.MS.Date.In UW Review",
    "Log.MS.Date.UW Decision",
    "Log.MS.Date.Condition Review",
    "MS.STATUSDATE",
    "Log.MS.Date.Initial Approval",
    "Log.MS.Date.Conditional Approval",
    "Log.MS.Date.Submit for Final Review",
    "Log.MS.Date.CTC",
    "Log.MS.Date.Closed Loan Submitted",
    "Log.MS.Date.In Purchase Review",
    "Log.MS.Date.Purchasing Suspense",
    "Log.MS.Date.Purchasing Condition Review",
    "Log.MS.Date.Cleared for Purchase",
    "Log.MS.Date.Purchased"
];

export const keyDatesFields = [
    "Log.MS.Date.Started",
    "Log.MS.Date.Registered",
    "3152", // LE Sent
    "3983", // eConsent
    "Log.MS.Date.Setup",
    "Log.MS.Date.Submitted to UW",
    "2966", // Estimated Closing
    "Log.MS.Date.Cond. Approval",
    "Log.MS.Date.Initial Approval", // Initial approval as conditional approval on key dates after milestone sequence changes
    "Log.MS.Date.Condition Review",
    "Log.MS.Date.Submit for Condition Review", //new field for Condition review after milestone sequence changed
    "Log.MS.Date.Submit for Final Review", //new field for submitter for finalreview after milestone sequence changed
    "Log.MS.Date.Final UW",
    "3977", // CD Sent
    "Log.MS.Date.CTC",
    "Log.MS.Date.Ready for Docs",
    "Log.MS.Date.Docs Out",
    "Log.MS.Date.Funding",
    "761",  // Lock Date
    "762",  // Lock Expiration
    "2302", // Approval Expiration
    "CX.COE.DATE",   // Close of Escrow
    "CX.ER.REQ.DATE", //entity request date
    "CX.ER.REV.DATE", //entity review date
    "2359", //CDA Ordered Date
    "2360", //CDA Completed Date
    "CX.APPR.FULFILLEDDATE", //Appraisal Received Date

    // CU Review #1
    "CX.CU1.REQUEST01.REQ.DATE", // CU1 Requested Date
    "CX.CU1.REQUEST01.REV.DATE", // CU1 Reviewed Date
    "CX.CUREVIEW.HISTORY", // CU Review History (to get latest action date)

    // Exception (Pre-Submission and Post-Submission 1-3)
    "CX.EXC.PRE.REQ.DATE",
    "CX.EXC.PRE.SEC.DECDATE",
    "CX.EXC.POST.REQ.DATE1",
    "CX.EXC.POST.SEC.DECDATE1",
    "CX.EXC.POST.REQ.DATE2",
    "CX.EXC.POST.SEC.DECDATE2",
    "CX.EXC.POST.REQ.DATE3",
    "CX.EXC.POST.SEC.DECDATE3",

    // Condo Review
    "CX.CONDR.PRO.REV.REQ.DATE",
    "CX.CONDR.DEC.DATE",

    // Consumer only
    "3153", // LE Signed Date (Consumer only)
    "3978", // CD Signed Date (Consumer only)

    // TODO - client needs to provide these IDs
    // "CX.EXCEPTION.REQUEST.DATE",
    // "CX.EXCEPTION.REVIEW.DATE",
    // "4506.ORDERED.DATE.FIELDID"
];

export const loanDetailsFields = [
    "1109", "2", "3", "1401", "1548", "1811", "CX.LOAN.TYPE", "16",
    "HMDA.X36", "356", "1821", "299", "MS.STATUS", "4209", "CX.FEES.FLOOD.INDICATOR",
    "608", "4", "4085", "11", "12", "14", "15", "VASUMM.X23", "136", "353", "19",
    "CX.LOAN.PRODUCT.NAME", "740", "742", //DTI top/bottom
    "CX.LOAN.LOCK.STATUS",//custom field having polly webhook lock status
    "CX.DSCR.CALCULATED",// DSCR with Asset Depletion 
    "CX.DOC.TYPE",
    "2626", "TPO.X88",
    "CX.GROSS.RENT",
    "CX.NONQ.30", // Qualifying income (BP loan only)
    "228",        // P&I
    "233",        // HOA Dues
    "912",        // PITI
    "230",        // Insurance
    "1405",       // Property Taxes
    "675",        // Prepayment Penalty
    "CX.PPP.TYPE",// Prepayment Penalty Type
    "CX.PPP.TERM",// Prepayment Penalty Term
    "LOANFOLDER", // Loan Folder
];

export const compensationFields = [
    "LCP.X1", "LCP.X6", "LCP.X7", "LCP.X8",
    "NEWHUD.X1143", "NEWHUD.X1144",
    "CX.BROKER.YSP.PCT", "CX.BROKER.YSP.AMT", "4788", "389"
];

export const complianceReviewFields = [
    "COMPLIANCEREVIEW.X7", "COMPLIANCEREVIEW.X16", "COMPLIANCEREVIEW.X12"
];

export const combinedFields = Array.from(
    new Set([
        ...milestoneFields,
        ...keyDatesFields,
        ...loanDetailsFields,
        ...compensationFields,
        ...complianceReviewFields
    ])
);


const exceptionDateFields = [
    { sequence: 0, requestField: "CX.EXC.PRE.REQ.DATE", decisionField: "CX.EXC.PRE.SEC.DECDATE" },
    { sequence: 1, requestField: "CX.EXC.POST.REQ.DATE1", decisionField: "CX.EXC.POST.SEC.DECDATE1" },
    { sequence: 2, requestField: "CX.EXC.POST.REQ.DATE2", decisionField: "CX.EXC.POST.SEC.DECDATE2" },
    { sequence: 3, requestField: "CX.EXC.POST.REQ.DATE3", decisionField: "CX.EXC.POST.SEC.DECDATE3" }
];

const getExceptionDateTimestamp = (value) => {
    if (!value || value === "//") return null;

    const normalizedValue = String(value).trim();
    const isoDateMatch = normalizedValue.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    const usDateMatch = normalizedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);

    if (isoDateMatch) {
        return Date.UTC(Number(isoDateMatch[1]), Number(isoDateMatch[2]) - 1, Number(isoDateMatch[3]));
    }

    if (usDateMatch) {
        return Date.UTC(Number(usDateMatch[3]), Number(usDateMatch[1]) - 1, Number(usDateMatch[2]));
    }

    const requestTimestamp = new Date(normalizedValue).getTime();
    return Number.isNaN(requestTimestamp) ? null : requestTimestamp;
};

export const getMostRecentExceptionDateFields = (fields) => {
    const exceptions = exceptionDateFields
        .map(exception => {
            const requestDate = fields[exception.requestField];
            const requestTimestamp = getExceptionDateTimestamp(requestDate);
            if (requestTimestamp === null) return null;

            return { ...exception, requestTimestamp };
        })
        .filter(Boolean)
        .sort((a, b) => b.requestTimestamp - a.requestTimestamp || b.sequence - a.sequence);

    return exceptions[0] || null;
};